export interface ErrorWithMessage {
  error_description?: string
  message: string
}

export const isErrorWithMessage = (error: unknown): error is ErrorWithMessage => (
  !!error && typeof error === 'object' && 'message' in error
)

export const messageFromError = (error: unknown, fallback?: string) => {
  return isErrorWithMessage(error) ? error.message : fallback || JSON.stringify(error)
}
